import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getSurveyByUuid({ commit }, uuid) {
      try {
        const response = await api.get(`/surveys/${uuid}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getSurveyQuestionsByUuid({ commit }, uuid) {
      try {
        const response = await api.get(`/surveys/${uuid}/questions`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async setSurveyAsRead({ commit }, id) {
      try {
        const response = await api.post(`/surveys/${id}/viewed`)
        return response
      } catch (error) {
        throw error
      }
    },

    async finishSurvey({ commit }, id) {
      try {
        const response = await api.post(`/surveys/${id}/finish`)
        return response
      } catch (error) {
        throw error
      }
    },

    async setAnswer({ commit }, data) {
      try {
        const response = await api.put(
          `/surveys/${data.distributionUserUuid}/answers/${data.id}`,
          data,
        )
        return response
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
